import { FormattedMessage, FormattedDate } from "react-intl";
import { useState } from "react";
import Icon from "@mdi/react";
import { mdiChevronDown, mdiChevronUp } from "@mdi/js";
import { DynamicApiRoutes } from "../../routes";
import { useApiGet } from "../../hooks/useApiGet";

import "./Announcements.scss";
import { useCustomerId } from "../../hooks/useCustomerId";

export function Announcements() {
	const customerId = useCustomerId();

	const { result: announcements } = useApiGet<IAnnouncement[]>(
		DynamicApiRoutes.Announcement(customerId)
	);
	return announcements && announcements.length > 0 ? (
		<nav className="Announcements panel is-black is-shadowless">
			<p className="panel-heading is-small has-text-warning px-2 py-1">
				<FormattedMessage id="AnnouncementPartial_Title" />
			</p>
			{announcements.map((announcement, index) => (
				<Announcement key={index} {...announcement} />
			))}
		</nav>
	) : null;
}

interface IAnnouncement {
	id: string;
	title: string;
	body: string;
	displayDate: Date;
}

function Announcement({ title, body, displayDate }: IAnnouncement) {
	const [expanded, setExpanded] = useState(false);
	return (
		<article
			className="panel-block has-background-warning-light is-flex-direction-column is-align-items-flex-start p-2"
			onClick={() => setExpanded(true)}
		>
			<div className="is-flex custom-title">
				<div className="custom-title__text">
					<p className="subtitle is-7">
						<FormattedDate value={displayDate} />
					</p>
					<h3 className="title is-7">{title}</h3>
				</div>
				<div>
					<button
						className="button is-small is-pulled-right"
						onClick={(event) => {
							event.stopPropagation();
							setExpanded(!expanded);
						}}
					>
						<span className="icon">
							<Icon
								path={expanded ? mdiChevronUp : mdiChevronDown}
							/>
						</span>
					</button>
				</div>
			</div>
			{expanded && (
				<div
					className="content is-small m-1"
					dangerouslySetInnerHTML={{ __html: body }}
				/>
			)}
		</article>
	);
}
